<template>
  <div id="page-map">
    <div id="map-surrounding">
      <l-map
          id="leaflet-map"
          ref="map"
          :center.sync="leafletCenter"
          :zoom.sync="zoom"
          :bounds.sync="bounds"
          @contextmenu="addMarker"
          @update:bounds="boundsUpdated"
          @ready="onMapReady"
      >
        <l-control-layers position="bottomleft"></l-control-layers>
        <l-marker ref="newmarker" :icon="addIcon" :lat-lng="newmarker">
          <l-popup ref="newpopup" :options="newPopupOptions">
            <b>{{ $t('choose_add_content_type_map') }}</b> <br/><br/>
            <template v-if="newmarker.lat">
              <router-link :to="{name: 'addItemPos', params: {lat: newmarker.lat, lng: newmarker.lng, type: ' '}}">
                {{ $t('add_item') }}
              </router-link>
              <div style="display: grid;grid-template-columns:repeat(4,1fr);">
                <span v-for="(itemtype,index) in itemTypeIcons" :key="index">
                  <router-link
                      :to="{name: 'addItemPos', params: {lat: newmarker.lat, lng: newmarker.lng, type: index}}">
                    <b-tooltip :label="$t('item_type_'+index)">
                      <img :src="itemTypeIcons[index].options.iconUrl" style="height: 30px; display: inline">
                    </b-tooltip>
                  </router-link>
                </span>
              </div>
            </template>
            <br/>
            <a :href="getMarkerURLAddOSM(newmarker)" target="_blank">
              <span><i class="fas fa-external-link-alt"></i></span>
              <span>{{ $t('add_osm') }}</span>
            </a>
            <div style="display: grid;grid-template-columns:repeat(4,1fr);">
              <span v-for="(extraCategory, index) in addableEcats()" :key="index">
                <b-tooltip :label="$tc('map_ecat_'+ extraCategory.category, 1)">
                  <a :href="getMarkerURLAddSpecificOSM(newmarker,extraCategory.category)" target="_blank">
                    <img :src="extraCategoriesIcons[extraCategories[extraCategory.category].id].options.iconUrl"
                         style="width: 24px; display: inline">
                  </a>
                </b-tooltip>
              </span>
            </div>
            <br/>
            <a :href="getMarkerURLAddFF(newmarker)" target="_blank">
              <span><i class="fas fa-external-link-alt"></i></span>
              <span>
                {{ $t('add_ffruit') }}<br/>
                <b-tooltip :label="$tc('map_ecat_FLF',1)">
                  <img :src="extraCategoriesIcons[extraCategories['FLF'].id].options.iconUrl"
                       style="width: 24px; display: inline">
                </b-tooltip>
              </span>
            </a>
            <br/>
          </l-popup>
        </l-marker>
        <v-geosearch :options="geosearchOptions"></v-geosearch>
        <l-tile-layer
            v-for="tileProvider in tileProviders"
            :key="tileProvider.name"
            :attribution="tileProvider.attribution"
            :name="tileProvider.name"
            :url="tileProvider.url"
            :visible="tileProvider.visible"
            layer-type="base"/>
        <l-control position="topright">
          <div class="is-flex is-flex-direction-column">
            <b-tooltip :label="$t('use-geolocation')" class="w-75 mt-1" position="is-left" type="is-info">
              <b-button expanded type="is-info" @click="setCenterAtGeoLocation">
                <i class="fas fa-street-view"></i>
              </b-button>
            </b-tooltip>
            <b-tooltip :label="$t('use-reflocation')" class="w-75 mt-1" position="is-left" type="is-info">
              <b-button expanded type="is-info" @click="setCenterAtRefLocation">
                <i class="fas fa-home"></i>
              </b-button>
            </b-tooltip>
            <b-tooltip :label="$t('filter-items')" class="w-75 mt-1" position="is-left" type="is-primary">
              <b-button expanded type="is-primary" @click="openFlap('filters')">
                <i class="fas fa-filter"></i>
              </b-button>
            </b-tooltip>
            <b-tooltip :label="$t('open-map-settings')" class="w-75 mt-1" position="is-left" type="is-primary">
              <b-button expanded type="is-primary" @click="openFlap('settings')">
                <i class="fas fa-cog"></i>
              </b-button>
            </b-tooltip>
	    <b-tooltip :label="$t('add-map-content')" class="w-75 mt-1" position="is-left" type="is-info">
              <b-button expanded type="is-info" @click="addMarker">
                <i class="fas fa-plus-circle"></i>
              </b-button>
            </b-tooltip>
          </div>
        </l-control>
        <l-control position="bottomleft">
          <div class="control-loading">
            <i v-show="mapLoading" class="fas fa-spinner fa-2x fa-pulse"></i>
          </div>
          <div v-show="zoom < minZoomToShowElements" class="control-zoom-info leaflet-control-attribution">
            {{ $t('too-small-zoom') }}
          </div>
        </l-control>

        <l-marker v-if="geoLocation" :icon="geoLocationIcon" :lat-lng="geoLocation.leafletLatLng"/>
        <l-marker v-if="refLocation" :icon="refLocationIcon" :lat-lng="refLocation.leafletLatLng"/>

        <l-layer-group v-if="zoom >= minZoomToShowElements">
          <v-marker-cluster :options="markerClusterGroupOptions">
            <l-marker
                v-for="item in items"
                :key="item.id"
                :ref="'marker-item-' + item.id"
                :icon="item.icon"
                :lat-lng="item.location.leafletLatLng"
            >
              <l-popup :options="{className:'item-popup', maxWidth: '500'}">
                <item-map-popup :item="item"/>
              </l-popup>
            </l-marker>
          </v-marker-cluster>
        </l-layer-group>
        <l-feature-group v-if="zoom >= minZoomToShowElements">
          <l-layer-group>
            <v-marker-cluster :options="extraLayersMarkerClusterGroupOptions">
              <template v-for="extraCategory in user.map_ecats">
                <l-marker
                    v-for="marker in extraCategories[extraCategory.category].markers"
                    :key="marker.id"
                    :icon="extraCategoriesIcons[extraCategories[extraCategory.category].id]"
                    :lat-lng="marker.location.leafletLatLng"
                    :visible="extraCategory.selected"
                >
                  <l-popup>
                    <div v-if="marker.name"><strong>{{ marker.name }}</strong></div>
                    <figure class="image">
                      <img v-if="marker.image" :alt="marker.image" :src="marker.image">
                    </figure>
                    <div class="is-grey">{{ $tc('map_ecat_' + extraCategory.category, 1) }}</div>
		    
                    <div class="is-grey" v-if="marker.description">{{ marker.description }}</div>
                    <div v-if="marker.opening_hours || marker.website">
		       <span> <b-tooltip v-if="marker.opening_hours" :label="marker.opening_hours"> <i class="far fa-clock">  </i> </b-tooltip> </span> 
		       &nbsp; <span>  <b-tooltip v-if="marker.website" :label="marker.website">   <a :href="marker.website" target="_blank">  <i class="fas fa-globe"> </i> </a>  </b-tooltip>  </span>
		    </div>
		    <div>
                      <a :href="getMarkerURLView(extraCategory.category, marker)" target="_blank">
                        <span><i class="fas fa-external-link-alt"></i></span>
                        <span>{{ $t(extraCategory.category === 'FLF' ? 'view-from-ff' : 'view-from-osm') }}</span>
			<span v-if="extraCategory.category == 'REP'"> {{ $t('dates_places') }}</span>
			<span v-if="extraCategory.category == 'VOL'"> {{ $t('dates_places') }}</span>
                      </a>
                      <span v-if="!['REP', 'VOL'].includes(extraCategory.category)"> {{ $t('or') }} </span>
                      <span v-if="!['REP', 'VOL'].includes(extraCategory.category)">
			<a :href="getMarkerURLEdit(extraCategory.category, marker)" target="_blank">
                          <span><i class="fas fa-external-link-alt"></i></span>
                          <span>{{ $t('edit_minor') }}</span>
                      </a></span>
                      <span v-if="!['REP', 'VOL'].includes(extraCategory.category)"> {{ $t(extraCategory.category === 'FLF' ? 'from-ff' : 'from-osm')}}</span>
                      <br/>
                    </div>
		                <div v-if="ecatsInteractive(extraCategory.category)"> 
                      <span>{{ $t('add-a')}}
                        <router-link :to="{name: 'addItemPos', params: {lat: marker.location.leafletLatLng.lat, lng: marker.location.leafletLatLng.lng, type: 'RQ', resource: extraCategory.category, rid: marker.id}}">
                          <b-tooltip :label="$t('item_type_RQ')">
                            <img :src="itemTypeIcons['RQ'].options.iconUrl" style="height: 20px; display: inline">
                          </b-tooltip>
                        </router-link> 
                          {{ $t('or')}} 
                        <router-link :to="{name: 'addItemPos', params: {lat: marker.location.leafletLatLng.lat, lng: marker.location.leafletLatLng.lng, type: 'DN', resource: extraCategory.category, rid: marker.id}}">
                          <b-tooltip :label="$t('item_type_DN')">
                            <img :src="itemTypeIcons['DN'].options.iconUrl" style="height: 20px; display: inline">
                          </b-tooltip>
                        </router-link>
                      </span>
                  </div>
                  </l-popup>
                </l-marker>
              </template>
            </v-marker-cluster>
          </l-layer-group>
        </l-feature-group>
      </l-map>
      <div id="flaps">
        <div class="flap settings">
          <div class="inner">
            <header class="is-flex">
              <h2 class="title">{{ $t('settings') }}</h2>
              <b-button
                  class="close"
                  outlined
                  type="is-dark"
                  @click="closeFlap"
              >
                <i class="fas fa-times"></i>
              </b-button>
            </header>
            <div class="content">
              <h3 class="title is-size-4 mb-1">{{ $t('external-public-resources') }}</h3>
              <p class="subtitle is-size-6 mt-0 mb-5">{{ $t('define-elements-to-see-on-map') }}</p>
              <div class="columns is-mobile buttons m-0 mb-4">
                <div class="column p-0 pr-2">
                  <b-button expanded type="is-primary" @click="selectAll">{{ $t('select-all') }}</b-button>
                </div>
                <div class="column p-0 pl-2">
                  <b-button expanded type="is-danger" @click="deselectAll">{{ $t('deselect-all') }}</b-button>
                </div>
              </div>
              <div id="ecats-checkboxes" class="columns is-mobile is-flex-wrap-wrap m-0">
                <div v-for="(extraCategory, index) in user.map_ecats" :key="index"
                     :class="{'pr-2': index % 2 === 0, 'pl-2': index % 2 !== 0}"
                     class="column is-half p-0 pb-2">
                  <b-field>
                    <b-checkbox v-model="ecatsCheckboxes" :native-value="extraCategory.category" type="is-primary">
                      <img :src="extraCategoriesIcons[extraCategories[extraCategory.category].id].options.iconUrl"
                           class="mr-1" style="width: 24px; vertical-align: middle;">
                      {{ $tc('map_ecat_' + extraCategory.category, 0) }}
                    </b-checkbox>
                  </b-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flap filters">
          <div class="inner">
            <header class="is-flex">
              <h2 class="title">{{ $tc('filter', 0) }}</h2>
              <b-button
                  class="close"
                  outlined
                  type="is-dark"
                  @click="closeFlap"
              >
                <i class="fas fa-times"></i>
              </b-button>
            </header>
            <div class="content">
              <items-filters
                  :boxed="false"
                  :limited-vertical-space="false"
                  :locationFilter="false"
                  rewrite-url-page-name="map"
                  @fieldsUpdated="itemFiltersUpdated"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as L from 'leaflet'; // do not remove for markercluster
import "leaflet.markercluster";
import "leaflet-easybutton";
import axios from "axios";
 //import "leaflet-geosearch";
import {formattedDate} from "@/functions";


 import {
     greenIcon,
     yellowIcon,
     redIcon,
     greyIcon,
     eventIcon,
     publicBookcaseIcon,
     aedIcon,
     giveBoxIcon,
     drinkingWaterIcon,
     freeShopIcon,
     foodSharingIcon,
     foodBankIcon,
     soupKitchenIcon,
     fallingfruitIcon,
     repairCafeIcon,
     volunteerIcon,
     blueIcon,
     addIcon,
     homeIcon
 } from "@/map-icons";

import {LMap, LTileLayer, LControlLayers, LControl, LMarker, LPopup, LFeatureGroup, LLayerGroup} from "vue2-leaflet";
import Vue2LeafletMarkercluster from "vue2-leaflet-markercluster";
import ItemMapPopup from "@/components/ItemMapPopup.vue";
import ErrorHandler from "@/mixins/ErrorHandler";
import {GeolocationCoords, lcall, ucfirst} from "@/functions";
import {LatLng} from "leaflet/dist/leaflet-src.esm";
import WindowSize from "@/mixins/WindowSize";
import ItemsFilters from "@/components/ItemsFilters.vue";
import {OpenStreetMapProvider} from 'leaflet-geosearch';
import VGeoSearch from "vue2-leaflet-geosearch";

export default {
  name: 'TheMapView',
  mixins: [ErrorHandler, WindowSize],
  components: {
    ItemsFilters,
    ItemMapPopup,
    LMap,
    LTileLayer,
    LControlLayers,
    LControl,
    'v-geosearch': VGeoSearch,
    LLayerGroup,
    LPopup,
    LMarker,
    LFeatureGroup,
    'v-marker-cluster': Vue2LeafletMarkercluster
  },
  data() {
    return {
      mapLoading: true,
      zoom: 14,
      maxZoom: 19,
      preLeafletCenter: new LatLng(50.6450944, 5.5736112),
      leafletCenter: new LatLng(50.6450944, 5.5736112),
      flapOpened: false,
      flapSelected: null,
      ecatsCheckboxes: [],
      waitingFormResponse: false,
      lastZoom: 15, //lastZoom bigger than zoom for the first updateBounds
      newmarker: [0, 0], //window middle?
      newPopupOptions: {autoPan: false, maxWidth: '200'},
      bounds: null,
      boundsLoaded: null,
      searchBounds: null,
      geoLocation: null,
      refLocation: null,
      filteredQueryValues: {},
      builtURLParams: {},
      initialItemsLoadDone: false,
      user: {},
      itemId: null,
      tileProviders: [
        {
          name: this.$t('tilemap_osm_humanitarian'),
          visible: true,
          url: "https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png",
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, tiles &copy <a href="https://www.hotosm.org/" target="_blank">Humanitarian OSM Team</a>, hosted by <a href="https://openstreetmap.fr/" target="_blank">OSM France</a>',
        },
        {
          name: this.$t('tilemap_osm_standard'),
          visible: false,
          attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        },
        {
          name: this.$t('tilemap_cyclosm'),
          visible: false,
          url: 'https://{s}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png',
          attribution: '&copy; <a href="https://github.com/cyclosm/cyclosm-cartocss-style/releases">CyclOSM</a> & <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        },
        {
          name: this.$t('tilemap_transport'),
          visible: false,
          url: 'https://tile.thunderforest.com/transport/{z}/{x}/{y}.png?apikey=a940a24136c24077857d0f9e0faa5a9f',
          attribution: '&copy;  <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, tiles &copy <a href="https://www.thunderforest.com/maps/transport/">Thunderforest</a>',
        },
        {
          name: this.$t('tilemap_transport_dark'),
          visible: false,
          url: 'https://tile.thunderforest.com/transport-dark/{z}/{x}/{y}.png?apikey=a940a24136c24077857d0f9e0faa5a9f',
          attribution: '&copy;  <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, tiles &copy <a href="https://www.thunderforest.com/maps/transport/">Thunderforest</a>',
        },

        {
          name: this.$t('tilemap_neighbourhood'),
          visible: false,
          url: 'https://tile.thunderforest.com/neighbourhood/{z}/{x}/{y}.png?apikey=a940a24136c24077857d0f9e0faa5a9f',
          attribution: '&copy;  <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, tiles &copy <a href="https://www.thunderforest.com/maps/transport/">Thunderforest</a>',
        },
        {
          name: this.$t('tilemap_outdoors'),
          visible: false,
          url: 'https://tile.thunderforest.com/outdoors/{z}/{x}/{y}.png?apikey=a940a24136c24077857d0f9e0faa5a9f',
          attribution: '&copy;  <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, tiles &copy <a href="https://www.thunderforest.com/maps/transport/">Thunderforest</a>',
        },

      ],
      geosearchOptions: {
        provider: new OpenStreetMapProvider(),
        searchLabel: this.$t('search_address'),
      },
      markerClusterGroupOptions: {
        chunkedLoading: true,
        maxClusterRadius: 15,
        disableClusteringAtZoom: 15,
      },
      minZoomToShowElements: 11,
      extraLayersMarkerClusterGroupOptions: {
        disableClusteringAtZoom: 16,
        chunkedLoading: true,
        maxClusterRadius: 40
      },
      extraCategories: {
        'BKC': {
          id: 'bookcases',
          markers: [],
          tagValue: 'public_bookcase'
        },
        'DEF': {
          id: 'defibrillators',
          markers: [],
          tagValue: 'defibrillator'
        },
        'DWS': {
          id: 'drinking-water-spots',
          markers: [],
          tagValue: 'drinking_water'
        },
        'FDB': {
          id: 'food-banks',
          markers: [],
          tagValue: 'food_bank'
        },
        'FDS': {
          id: 'food-sharings',
          markers: [],
          tagValue: 'food_sharing'
        },
        'FLF': {
          id: 'falling-fruits',
          markers: [],
          tagValue: 'ffruit'
        },
        'FRS': {
          id: 'free-shops',
          markers: [],
          tagValue: 'freeshop'
        },
        'GVB': {
          id: 'give-boxes',
          markers: [],
          tagValue: 'give_box'
        },
        'SPK': {
          id: 'soup-kitchens',
          markers: [],
          tagValue: 'soup_kitchen'
        },
	      'REP': {
          id: 'repair-cafes',
          markers: [],
          tagValue: 'repair_cafe'
        },
        'VOL': {
          id: 'volunteer-offers',
          markers: [],
          tagValue: 'volunteer_offer'
        },
      },
      extraLayersTagsOverpass: {
        'public_bookcase': 'amenity',
        'defibrillator': 'emergency',
        'give_box': 'amenity',
        'food_bank': 'social_facility',
        'food_sharing': 'amenity',
        'soup_kitchen': 'social_facility',
        'drinking_water': 'amenity',
        'freeshop': 'amenity'
      },
      extraCategoriesIcons: {
        'bookcases': publicBookcaseIcon,
        'defibrillators': aedIcon,
        'give-boxes': giveBoxIcon,
        'drinking-water-spots': drinkingWaterIcon,
        'free-shops': freeShopIcon,
        'food-sharings': foodSharingIcon,
        'food-banks': foodBankIcon,
        'soup-kitchens': soupKitchenIcon,
        'falling-fruits': fallingfruitIcon,
        'repair-cafes': repairCafeIcon,
        'volunteer-offers': volunteerIcon,
      },
      itemTypeIcons: {
        'DN': greenIcon,
        'LN': yellowIcon,
        'RQ': redIcon,
        'EV': eventIcon
      },
      geoLocationIcon: blueIcon,
      refLocationIcon: homeIcon,
      addIcon: addIcon,
      routedItemLocation: null,
      items: [],
      routedItemError: false,
      timeouts: {},
      baseURL: [ //URL from https://wiki.openstreetmap.org/wiki/Overpass_API
        'https://overpass-api.de/api',
        'https://maps.mail.ru/osm/tools/overpass/api',
        'https://overpass.private.coffee/api',
      ],
    }
  },
  async created() {
    document.title = `Shareish | ${this.$t('map')}`;

    if (this.isPosUsed) {
      this.routedItemLocation = new GeolocationCoords(this.PosLng, this.PosLat);
    } else if (this.$route.query.id)
      this.itemId = Number(this.$route.query.id);

    await this.updateGeoLocation();
      
    if (this.isAuthenticated) {
	await this.fetchUser();
    }

    else {
	//Create fake user.map_ecats to be able to display OSM/FF data while not logged in
	this.user.map_ecats = [{category: "BKC", selected: true},
			       {category: "DEF", selected: true},
			       {category: "DWS", selected: true},
			       {category: "FDB", selected: true},
			       {category: "FDS", selected: true},
			       {category: "FLF", selected: true},
			       {category: "FRS", selected: true},
			       {category: "GVB", selected: true},
			       {category: "SPK", selected: true},
			       {category: "REP", selected: true},
			       {category: "VOL", selected: true},
	];
    }
    for (const i in this.user.map_ecats) {
      if (this.user.map_ecats[i].selected === true)
        this.ecatsCheckboxes.push(this.user.map_ecats[i].category)
    }

    if (this.routedItemLocation) {
      this.preLeafletCenter = this.routedItemLocation.leafletLatLng;
    } else if (this.geoLocation instanceof GeolocationCoords)
      this.preLeafletCenter = this.geoLocation.leafletLatLng;
    else if (this.refLocation instanceof GeolocationCoords)
      this.preLeafletCenter = this.refLocation.leafletLatLng;

    if (this.itemId !== null)
      await this.fetchRoutedItem();

    this.leafletCenter = this.preLeafletCenter;

    this.mapLoading = false;

  },
  computed: {
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
    userId() {
      return Number(this.$store.state.user.id);
    },
    PosLat() {
      return Number(this.$route.params.lat);
    },
    PosLng() {
      return Number(this.$route.params.lng);
    },
    isPosUsed() {
      return (this.PosLat > 0 && this.PosLng > 0);
    },
  },
  watch: {
    ecatsCheckboxes() {
      this.ecatsCheckboxesUpdated();
    }
  },
  methods: {
    ucfirst,
    lcall,
    async ecatsCheckboxesUpdated() {
      for (const i in this.user.map_ecats) {
        const checkboxSelected = this.ecatsCheckboxes.includes(this.user.map_ecats[i].category);
        if (this.user.map_ecats[i].selected !== checkboxSelected) {
          try {
            await axios.patch(`/api/v1/map_ecats/${this.user.map_ecats[i].id}/`, {selected: checkboxSelected});
            this.user.map_ecats[i].selected = checkboxSelected;
          } catch (error) {
            this.snackbarError(error);
          }
        }
      }
    },
    addableEcats() {
      var addableCats = [];
      for (const i in this.user.map_ecats) {
	  if (!['FLF', 'REP', 'VOL'].includes(this.user.map_ecats[i].category))
	      addableCats.push(this.user.map_ecats[i])
      }
      return addableCats;
    },
    ecatsInteractive(category) {
	const interactiveCats = ['BKC', 'FDS', 'GVB','FRS','FDB','REP'];
	return(interactiveCats.indexOf(category)+1)
    },
    rewriteURL() {
      clearTimeout(this.timeouts['rewriteURL']);
      this.timeouts['rewriteURL'] = setTimeout(async () => {
        try {
          await this.$router.push({name: 'map', query: this.builtURLParams});
        } catch (error) {
          console.log("Redirected on same URL.");
        }
      }, 100);
    },
    itemFiltersUpdated(filteredQueryValues, builtURLParams) {
      this.builtURLParams = {...builtURLParams};
      this.rewriteURL();

      this.$store.commit('setItemsFilters', {
        builtURLParams: this.builtURLParams,
        keysToKeep: ['dr', 'lt', 'ordering', 'us']
      });

      clearTimeout(this.timeouts['itemFiltersUpdated']);
      this.timeouts['itemFiltersUpdated'] = setTimeout(() => {
        this.filteredQueryValues = filteredQueryValues;

        this.fetchItems(false);
      }, 600);
    },
    selectAll() {
      for (const i in this.user.map_ecats) {
        if (!this.ecatsCheckboxes.includes(this.user.map_ecats[i].category))
          this.ecatsCheckboxes.push(this.user.map_ecats[i].category);
      }
    },
    deselectAll() {
      this.ecatsCheckboxes = [];
    },
    async fetchUser() {
      try {
        const params = {
          columns: ['ref_location', 'map_ecats']
        }
        this.user = (await axios.get('/api/v1/users/me/', {params: params})).data;
	  
        if (this.user.ref_location !== null)
          this.refLocation = new GeolocationCoords(this.user.ref_location);
      } catch (error) {
        this.snackbarError(error);
      }
    },
    async updateGeoLocation() {
      // Has the user activated geolocation?
      if ('geolocation' in navigator) {
        // Get the position
        try {
          const position = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject, {
              maximumAge: 10000,
              timeout: 5000,
              enableHighAccuracy: true
            });
          });

          if (this.geoLocation instanceof GeolocationCoords)
            this.geoLocation.update(position);
          else
            this.geoLocation = new GeolocationCoords(position);
        } catch {
        }
      }
    },
    async setCenterAtGeoLocation() {
      await this.updateGeoLocation();
      if (this.geoLocation instanceof GeolocationCoords)
        this.leafletCenter = this.geoLocation.leafletLatLng;
      else
        this.snackbarError(this.$t('enable-geolocation-to-use-feature'));

    },
    async setCenterAtRefLocation() {
      if (this.refLocation instanceof GeolocationCoords)
        this.leafletCenter = this.refLocation.leafletLatLng;
      else
        this.snackbarError(this.$t('set-a-reflocation-to-use-feature'));
    },
    openFlap(name) {
      this.flapOpened = true;
      this.flapSelected = name;

      const flap = this.$el.querySelector(`#flaps .${this.flapSelected}`);
      if (this.windowWidth < 700) {
        flap.style.width = "calc(100% - 2 * .5rem)";
        flap.style.left = "0.5rem";
      } else {
        if (this.flapSelected === 'settings') {
          flap.style.width = "550px";
        } else if (this.flapSelected === 'filters') {
          flap.style.width = "450px";
        }
        flap.style.left = "calc(100% - " + flap.style.width + " - 0.5rem)";
      }
    },
    closeFlap() {
      if (this.flapOpened) {
        const flap = this.$el.querySelector(`#flaps .${this.flapSelected}`);
        flap.style.left = "100%";
        this.flapSelected = null;
        this.flapOpened = false;
      }
    },
    async fetchRoutedItem() {
      try {
        const routedItem = (await axios.get(`/api/v1/items/${this.itemId}`)).data;
        if (routedItem.location !== null) {
          this.routedItemLocation = new GeolocationCoords(routedItem.location);
          this.preLeafletCenter = this.routedItemLocation.leafletLatLng;
        } else {
          this.routedItemError = true;
          this.snackbarError(this.$t('this-item-doesnt-have-a-location'));
        }
      } catch (error) {
        this.routedItemError = true;
        this.snackbarError(error);
      }
    },
    async fetchItems() {
      if (this.zoom >= this.minZoomToShowElements && this.searchBounds != null) {
        try {
          const params = {...this.filteredQueryValues};
          params['bounds'] = [this.searchBounds[0].toString(), this.searchBounds[1].toString()];

          const items = (await axios.get("/api/v1/actives/", {params: params})).data;

          if (items.length > 0) {
            this.items = items.filter(item =>
                item['location'] !== null
            ).map(item => {
              return {
                ...item,
                icon: this.itemTypeIcons[item['type']] || greyIcon,
                location: new GeolocationCoords(item.location)
              };
            });
          } else {
            this.items = [];
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    async fetchExtraLayersMakers() {
      if (this.zoom >= this.minZoomToShowElements) {
        const elements = await Promise.all([
            this.getFallingFruitElements(), // elements[0]
            this.getRepairCafeElements(),  // elements[1]
            this.getVolunteerElements(), // elements[2],
            this.getOverPass(), //elements[3]
        ]);
        const tmpExtraCategories = {...this.extraCategories};

        for (const [key, extraCategory] of Object.entries(tmpExtraCategories)) {
          if (key === 'FLF') { // elements[0]
            tmpExtraCategories['FLF']['markers'] = elements[0].filter(element =>
                element['id'] != null && element['lat'] != null && element['lng'] != null
            ).map(element => {
              return {
                id: element['id'],
                type: 'ffruit',
                name: element['type_names'][0],
                description: element['description'],
                location: new GeolocationCoords(element['lng'], element['lat'])
              }
            });
          }
	        else if (key === 'REP') { //elements[1]
            tmpExtraCategories['REP']['markers'] = elements[1].filter(element =>
                element['name'] != null && element['coordinate'] != null
            ).map(element => {
              return {
                id: Math.floor(new Date(element['last_updated'].replace(" ", "T")).getTime() / 1000), // // convert date to integer for arbitrary id
                //parseInt(btoa(element['external_link']).replace(/[^a-zA-Z0-9]/g, '').substr(0, 10), 36), // convert external_link to integer for arbitrary unique marker id
                type: extraCategory.tagValue,//'repair_cafe',
                image: "https://www.repaircafe.org/wp-content/uploads/2021/05/logo-repair-cafe-2.png", //"https://repairtogether.restarters.net/images/logos/repairtogether.png",
                name: element['name'],
                description: element['external_link'],
                location: new GeolocationCoords(parseFloat(element['coordinate'].split(",")[1]),parseFloat(element['coordinate'].split(",")[0]))
              }
            });
          }
          else if (key === 'VOL') { //elements[2]
            tmpExtraCategories['VOL']['markers'] = elements[2].filter(element =>
              element['ad'] != null && element['activity_place'] != null
            ).map(element => {
              return {
                id: element['ad']['nid'], 
                type: extraCategory.tagValue,//'volunteer-offer
                image: "https://www.levolontariat.be/themes/custom/volontariat_theme/images/logo-print.svg", 
                name: element['ad']['title']+' - '+element['group']['label'],
                //we store categories and date as a formatted string, not ideal (should be vue formatting data)
                description: this.getVolunteerCategories(element['hobbies']) + ' ('+ this.$t('published') +' ' + this.$t('on-day') + ' ' + formattedDate(new Date(element['ad']['changed']*1000),this.$i18n.locale) + ')',
                website: 'https://www.levolontariat.be/node/'+element['ad']['nid'],
                location: new GeolocationCoords(parseFloat(element['activity_place']['lng']),parseFloat(element['activity_place']['lat']))
              }
            });
          }
          else{
            const allOsmElements = elements[3];
            const tagValue = extraCategory.tagValue; 
            const tagKey = this.extraLayersTagsOverpass[tagValue];

            tmpExtraCategories[key]['markers'] = allOsmElements.filter(element => {
              return (
                element['id'] != null && 
                element['lat'] != null && 
                element['lon'] != null &&
                element['tags'] && 
                element['tags'][tagKey] === tagValue
              );
            }).map(element => {
              return {
                id: element['id'],
                type: tagValue,
                name: element['tags']['name'],
                location: new GeolocationCoords(element['lon'], element['lat']),
                opening_hours: element['tags']['opening_hours'],
                website: element['tags']['website'],
                image: element['tags']['panoramax'] != null ? "https://api.panoramax.xyz/api/pictures/"+element['tags']['panoramax']+"/thumb.jpg" : element['tags']['image:0'] != null ? element['tags']['image:0'] : element['tags']['image'],
              }
            });
          }
        }
        this.extraCategories = tmpExtraCategories;
      }
    },
    addMarker(e) {
	this.newmarker = e.latlng != null ? e.latlng : new LatLng(this.leafletCenter.lat,this.leafletCenter.lng);

      //this.$refs.map.mapObject.on('popupopen', function(e) {
      //    var px = this.$refs.map.mapObject.project(e.target._popup._latlng); // find the pixel location on the map where the popup anchor is
      //    px.y -= e.target._popup._container.clientHeight/2; // find the height of the popup container, divide by 2, subtract from the Y axis of marker location
      //    this.$refs.map.mapObject.panTo(map.unproject(px),{animate: true}); // pan to new center
      //});


      this.$refs.newmarker.mapObject.setOpacity(1);
      this.$refs.newmarker.mapObject.getPopup().on('remove', function () {
        this._source.setOpacity(0);
      });
      this.$refs.newmarker.mapObject.openPopup();
	//this.$refs.map.mapObject.setView(this.newmarker);

    },
      formatTimestamp(timestamp) {
	  // Convert from seconds to milliseconds
	  const date = new Date(timestamp * 1000);
	  // Format to readable string 
	  return date.toLocaleDateString(); 
      },
      getVolunteerCategories(hobbies) {
	  if (!hobbies || typeof hobbies !== 'object') return '';
	  return Object.values(hobbies)
		       .map(hobby => hobby.name)
		       .filter(Boolean)
		       .join(', ');
      },
      
      getMarkerURLView(category, marker) {
	  if (category === 'FLF') {
              return "https://fallingfruit.org/locations/" + marker.id + "&locale=" + this.$i18n.locale;
	  }
	  else if (category === 'REP') {
	      return marker.description;
	  }
	  else if (category === 'VOL') {
	      return marker.website;
	  }
	  
	  else {
              return "https://openstreetmap.org/node/" + marker.id;
	}
    },
    getMarkerURLEdit(category, marker) {
	if (category === 'FLF') {
	return "https://fallingfruit.org/locations/" + marker.id + "/edit?c=forager%2Cfreegan&locale=" + this.$i18n.locale;
	}
	else if (category === 'BKC') {
	    return "https://mapcomplete.org/bookcases.html?z=19&lat="+marker.location.leafletLatLng.lat+"&lon="+marker.location.leafletLatLng.lng+"#node/"+marker.id
	}
        else if (category === "DEF") {
	     return "https://mapcomplete.org/aed?z=19&lat="+marker.location.leafletLatLng.lat+"&lon="+marker.location.leafletLatLng.lng+"#node/"+marker.id
	  }
	else if (category === "DWS") {
	    return "https://mapcomplete.org/drinking_water.html?z=19&lat="+marker.location.leafletLatLng.lat+"&lon="+marker.location.leafletLatLng.lng+"#node/"+marker.id
	}
	else if (category === "GVB") {
	    return "https://mapcomplete.org/theme.html?z=19&lat="+marker.location.leafletLatLng.lat+"&lon="+marker.location.leafletLatLng.lng+"&userlayout=https%3A%2F%2Fstudio.mapcomplete.org%2F75871%2Flayers%2Fgive_box%2Fgive_box.json#node/"+marker.id
	}
	else if (category === "FDS") {
	    return "https://mapcomplete.org/theme.html?z=19&lat="+marker.location.leafletLatLng.lat+"&lon="+marker.location.leafletLatLng.lng+"&userlayout=https%3A%2F%2Fstudio.mapcomplete.org%2F75871%2Flayers%2Ffood_sharing%2Ffood_sharing.json#node/"+marker.id
	}
	else {
	    return "https://openstreetmap.org/edit?node=" + marker.id + "#map=19/" + marker.location.leafletLatLng.lat + "/" + marker.location.leafletLatLng.lng;
      }
    },
    getMarkerURLAddOSM(marker) {
      return "https://openstreetmap.org/edit#map=20/" + marker.lat + "/" + marker.lng;
    },
    getMarkerURLAddSpecificOSM(marker,category) {
	if (category === "BKC") {
	    return "https://mapcomplete.org/bookcases.html?z=18&lat="+marker.lat+"&lon="+marker.lng;
	}
	else if (category === "GVB") {
	    return "https://mapcomplete.org/theme.html?z=19&lat="+marker.lat+"&lon="+marker.lng+"&userlayout=https%3A%2F%2Fstudio.mapcomplete.org%2F75871%2Flayers%2Fgive_box%2Fgive_box.json";
	}
	else if (category === "FDS") {
	    return "https://mapcomplete.org/theme.html?z=19&lat="+marker.lat+"&lon="+marker.lng+"&userlayout=https%3A%2F%2Fstudio.mapcomplete.org%2F75871%2Flayers%2Ffood_sharing%2Ffood_sharing.json";
	}
	
	else if (category === "DEF") {
	    return "https://mapcomplete.org/aed.html?z=18&lat="+marker.lat+"&lon="+marker.lng; 
	}
	else if (category === "DWS") {
	    return "https://mapcomplete.org/drinking_water.html?z=18&lat="+marker.lat+"&lon="+marker.lng; 
	}
	else return "https://openstreetmap.org/edit#map=20/" + marker.lat + "/" + marker.lng;
    },
    getMarkerURLAddFF(marker) {
      return "http://fallingfruit.org/locations/new?lat=" + marker.lat + "&lng=" + marker.lng + "&locale=" + this.$i18n.locale;
    },
    async getRepairCafeElements_frontend() { // not used anymore
	try {
	    const rpbaseURL = "https://www.repaircafe.org/wp-json/v1/map?";
	    const rpcoords = "northeast="+this.bounds.getNorthEast().lat + ',' + this.bounds.getNorthEast().lng +"&southwest="+ this.bounds.getSouthWest().lat + ',' + this.bounds.getSouthWest().lng;
	    const rpURL = rpbaseURL + rpcoords;
	    //const proxyURL = `https://corsproxy.io/?url=` + encodeURIComponent(rpURL); // Ajout du proxy
	    //const proxyURL = `https://api.allorigins.win/get?url=` + encodeURIComponent(rpURL); // Ajout du proxy
	    const proxyURL = "https://thingproxy.freeboard.io/fetch/" + rpURL;
            const response = await axios.get(proxyURL);
            return response.data; 
	} catch (error) {
            console.log(error);
            return [];
	}
    },
    async getRepairCafeElements() { //using django proxy to avoid CORS issue from frontend
	try {
	    const rpbaseURL = "https://www.repaircafe.org/wp-json/v1/map";
	    const response = await axios.get('/api/v1/proxy', {
		params: {
		    target: rpbaseURL,
		    northeast: this.bounds.getNorthEast().lat + ',' + this.bounds.getNorthEast().lng,
		    southwest: this.bounds.getSouthWest().lat + ',' + this.bounds.getSouthWest().lng
		    }
	    });
	    return response.data;
	} catch (error) {
            console.log(error);
            return [];
	}
    },
    async getFallingFruitElements() {
      try {
	  const ffbaseURL = 'https://fallingfruit.org/api/0.3/locations?api_key=48aa85bd5a23b892de4867ec848bcc99&locale=' + this.$i18n.locale + '&muni=false';
          const ffcoords = '&bounds=' + this.bounds.getSouthWest().lat + ',' + this.bounds.getSouthWest().lng + '|' + this.bounds.getNorthEast().lat + ',' + this.bounds.getNorthEast().lng;
          const ffURL = ffbaseURL + ffcoords;
        return (await axios.get(ffURL, {
          transformRequest: (data, headers) => {
            delete headers.common['Authorization'];
            return data;
          }
        })).data;
      } catch (error) {
        console.log(error);
        return [];
      }
    },
      async getVolunteerElements_frontend() { // not used anymore
	  try {
	      const vbaseURL = 'https://www.levolontariat.be/api/search?';
	      const vcoords = 'filter[location][condition][lat_min]=' + this.bounds.getSouthWest().lat + '&filter[location][condition][lat_max]=' + this.bounds.getNorthEast().lat + '&filter[location][condition][lng_min]=' + this.bounds.getSouthWest().lng + '&filter[location][condition][lng_max]=' + this.bounds.getNorthEast().lng + '&filter[accessibility][condition][lang]=false&filter[accessibility][condition][reduced]=false&filter[extra][condition][hobbies]=undefined&filter[extra][condition][times]=undefined';
	      const vURL = vbaseURL+vcoords;
	      const proxyURL = "https://thingproxy.freeboard.io/fetch/" + vURL;
	      const response = await axios.get(proxyURL);
              return response.data;
	  } catch (error) {
              return [];
	  }
      },

      async getVolunteerElements() {
	  try {
	      const vbaseURL = 'https://www.levolontariat.be/api/search?';
	      const response = await axios.get('/api/v1/proxy', {
		  params: {
		      target: vbaseURL,
		      'filter[location][condition][lat_min]': this.bounds.getSouthWest().lat,
		      'filter[location][condition][lat_max]': this.bounds.getNorthEast().lat,
		      'filter[location][condition][lng_min]': this.bounds.getSouthWest().lng,
		      'filter[location][condition][lng_max]': this.bounds.getNorthEast().lng,
		      'filter[accessibility][condition][lang]': false,
		      'filter[accessibility][condition][reduced]': false,
		      'filter[extra][condition][hobbies]': 'undefined',
		      'filter[extra][condition][times]': 'undefined'
		  }
	      });
              return response.data;
	  } catch (error) {
              return [];
	  }
      },
      //Single request overpass
       async getOverPass(){

	const bounds = this.bounds.pad(0.5);

	const bbox = [
  		bounds.getSouth(),
		bounds.getWest(),
		bounds.getNorth(),
		bounds.getEast()
		].join(",");

	const selectors = Object.entries(this.extraLayersTagsOverpass)
			  .map(([key, value]) =>
			  `node["${value}"="${key}"](${bbox});`
			  )
			  .join("\n");

	const data = `
		[out:json][timeout:50];
		(
		  ${selectors}
		);
		out body;
		`;

        //const overpass = {...this.extraLayersTagsOverpass};
        //const bounds = `${this.bounds.pad(0.5).getSouth()},${this.bounds.pad(0.5).getWest()},${this.bounds.pad(0.5).getNorth()},${this.bounds.pad(0.5).getEast()}`;
        //let nodeQuery = "(";
        //for(const[key, value] of Object.entries(overpass)){
        //  nodeQuery += `node["${value}"="${key}"](${bounds});`;
        //}
        //nodeQuery += ");";
        //const data = `[out:json][timeout:45];(${nodeQuery});out body;`;

        for(const url of this.baseURL){
          try{
            const response = await axios.get("/interpreter", {
              params: {data}, 
              baseURL: url,
              timeout: 60000 
            });

            return response.data['elements'];
          }catch(error){
            console.log(`le serveur ${url} est inaccessible`);
	    console.error("Overpass error", {
    		url,
    		status: error.response?.status,
    		message: error.message,
    		response: error.response?.data
  	    });
          }
        }
        console.log("Aucun serveur accessible");
        return [];
      },

      //Should we remove it ?
      async getOverPassElements(tagValue) {
        try {
              const bounds = `${this.bounds.getSouth()},${this.bounds.getWest()},${this.bounds.getNorth()},${this.bounds.getEast()}`;
              const nodeQuery = `node["${this.extraLayersTagsOverpass[tagValue]}"="${tagValue}"](${bounds});`;
              const data = `[out:json][timeout:15];(${nodeQuery});out body geom;`;

              const baseURL = "https://overpass-api.de/api";
              //const baseURL = "https://overpass.kumi.systems/api";
              //const baseURL = "https://maps.mail.ru/osm/tools/overpass/api";

              return (await axios.get("/interpreter", {params: {data}, baseURL})).data['elements'];
	  } catch (error) {
              console.log(error);
              return [];
	  }
    },
    //check if the area is on the boundsLoaded area
    boundsCheck(){
      if(this.boundsLoaded === null){return false;}

      return this.boundsLoaded.contains(this.bounds);
    },
    async boundsUpdated() {
      clearTimeout(this.timeouts['boundsUpdated']);
      this.timeouts['boundsUpdated'] = setTimeout(async () => {
      if (this.boundsCheck()) {
        return;
      }
      else{
        this.mapLoading = true;

        const NWCoords = [this.bounds.getNorthWest().lng, this.bounds.getNorthWest().lat];
        const SECoords = [this.bounds.getSouthEast().lng, this.bounds.getSouthEast().lat];
        if (this.searchBounds === null) {
          this.searchBounds = [new GeolocationCoords(NWCoords), new GeolocationCoords(SECoords)];
        } else {
          this.searchBounds[0].update(NWCoords);
          this.searchBounds[1].update(SECoords);
        }

        if (this.isAuthenticated) {
	        await this.fetchItems(this.filteredQueryValues);
        }
        else {
          this.snackbarError(this.$t('better_if_connected'),{timeout:3000});
        }

        if (!this.initialItemsLoadDone) {
          if (this.itemId !== null && !this.routedItemError) {
            this.$nextTick(() => {
              this.$refs[`marker-item-${this.itemId}`][0].mapObject.openPopup();
            });
          }

          this.initialItemsLoadDone = true;
        }

        await this.fetchExtraLayersMakers();
        if(this.zoom >= this.minZoomToShowElements){
         const nw = this.bounds.getNorthWest();
          const se = this.bounds.getSouthEast();
          this.boundsLoaded = L.latLngBounds(
          L.latLng(nw.lat, nw.lng),
          L.latLng(se.lat, se.lng)
        ); 
        }else{
          this.boundsLoaded = null;
        }
        
        this.mapLoading = false;
      }
      }, 600);
    },
    async fetchMathElements() {
      this.mapLoading = true;
      await this.fetchItems(this.filteredQueryValues);
      await this.fetchExtraLayersMakers();
      this.mapLoading = false;
    },
    windowSizeChanged() {
      if (this.flapOpened) {
        const flap = this.$el.querySelector(`#flaps .${this.flapSelected}`);
        if (this.windowWidth < 700) {
          flap.style.width = "calc(100% - 2 * 0.5rem)";
          flap.style.left = "0.5rem";
        } else {
          if (this.flapSelected === 'settings') {
            flap.style.width = "550px";
          } else if (this.flapSelected === 'filters') {
              flap.style.width = "450px";
          }
          flap.style.left = "calc(100% - " + flap.style.width + " - 0.5rem)";
        }
      }
    },
    onMapReady(map){
      this.bounds = map.getBounds();
      this.boundsUpdated();
    },
  }
}
</script>

<style>
@media screen and (max-width: 1023px) {
  #wrapper > .section {
    padding: 1.5rem !important;
  }
}
</style>

<style lang="scss" scoped>

#selected-categories {
  .selected-category {
    padding: 0;
    margin: 0 0 5px 0;
    font-size: 0.75rem;
    background-color: white;
    border-radius: 5px;

    .column.name {
      padding: 10px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .column.close {
      flex: 0 0 40px;
      padding: 10px;
      text-align: center;
      cursor: pointer;

      i {
        vertical-align: middle;
      }
    }

    &:last-child {
      margin-bottom: 0.75rem !important;
    }
  }
}

#leaflet-map {
  height: calc(100vh - 52px - 2 * 3rem);
  z-index: 1;
}

.fa-external-link-alt {
  margin-right: 0.25rem;
}

.control-zoom-info {
  margin-left: -10px;
  margin-bottom: -10px;
}

#map-surrounding {
  position: relative;
  overflow: hidden;
}

#flaps .flap {
  position: absolute;
  top: 0.5rem;
  bottom: 0.5rem;
  left: 100%;
  z-index: 1;
  transition: left 0.25s;

  .inner {
    padding: 1.25rem;
    background-color: #fff;
    overflow: auto;
    border-radius: 5px;
    max-height: 100%;

    .title {
      width: 100%;
      line-height: 40px;
    }

    .close {
      flex: 0 0 auto;
    }
  }
}

@media screen and (max-width: 1024px) {
  #leaflet-map {
    height: calc(100vh - 52px - 2 * 1.5rem);
  }
}

@media screen and (max-width: 700px) {
  #flaps .flap .inner .settings .content .columns {
    display: block;

    & > .column {
      width: 100%;
      padding: 0 0 0.5rem 0 !important;
    }
  }
}
</style>
